const actions = {
    // 加载状态
    loading: ({commit}) => commit('LOADING'),
    // 历史搜索
    history: ({commit}, arr) => commit('SAVEHISTORY', arr),
    // 清空历史搜索
    clearHistory: ({commit}) => commit('CLEARHISTORY'),
    // 获取购物车列表
    getCarlist: ({commit}) => commit('GETCARLIST'),
    // 设置购物车数量
    setCarNumber: ({commit}, number) => commit('SETCARNUMBER', number),
    // 设置登陆弹出框
    setTip: ({commit}, flag) => commit('SETTIP', flag)
}
;
export default actions
